/**
 *
 *  Radio Patmos Web player functionalities
 *      
 */

(function($) {
  $(document).ready(function() {

    var $audio = $('#patmos-radio-stream');
    var $button = $('.web-player .play-button');

    // do not play before Ad
    //$audio.get(0).play();
    
    $audio.on('play', function() {
      $button.removeClass('play');
    });

    $button.click(function() {
      if ($button.hasClass('play')) {
        $audio.get(0).play();
        $button.removeClass('play');
      } else {
        $audio.get(0).pause();
        $button.addClass('play');
      }
    });

    function shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    }
  
    function getAds() {
        const latestAdId = localStorage.getItem('patmosAdId');
        const adsJsonPath = "/wp-content/uploads/patmos_ads.json";
        $.getJSON(adsJsonPath, function(data){
        if (data.length == 0) {
            audio.play();
            return;
        }
        if ( latestAdId !== null && data.length > 1) {
            for(var i = 0; i < data.length; i++) {
              if ( data[i].ad_id === latestAdId ) { delete data[i]; }
            }
            data = data.filter(function(){return true;});
        }

        var adArray = Object.keys(data);
        shuffle(adArray);
        localStorage.setItem('patmosAdId', data[adArray[0]].ad_id);
        var audio = document.getElementById("patmos-radio-stream");
        var oldsrc = audio.src;
        audio.src = data[adArray[0]].ad_audio;

        audio.addEventListener('ended', function(e) {
            audio.src = oldsrc;
            audio.play();
        }, true);

        }).fail(function(){
            console.log("Ad skipped");
            audio.play();
        });

        try { 
            audio.play();
        } catch(error) {
            console.log("autoplay not allowed");
        }
    }

    function getType(t) {
        if (t == 59) {
            return "radio";
        }
        if (t == 61) {
            return "speech";
        }
        if (t == 53 || t == 54) {
            return "news";
        }
        if (t > 19 && t < 44) {
            return "music";
        }
        if (t > 65) {
            return "music";
        }
        return "";
    }

    function getData(data) {
        var rv = {
            title: "",
            name: "",
            type:"",
            current_state: 0
        };
        rv.scheduled_time = data.themes.current.theme_schedule;

        // resolve percent
        var next = data.themes.next.theme_schedule;
        var d = new Date();
        var hoursnow = d.getHours();
        var minutesnow = d.getMinutes();
        var secondsnow = d.getSeconds();
        var split = rv.scheduled_time.split(":");
        var split2 = next.split(":");
        var hdiff = parseInt(split[0]) - hoursnow;
        var mdiff = parseInt(split[1]) - minutesnow;
        var sdiff = parseInt(split[2]) - secondsnow;
        var secElapsed = hdiff*3600 + mdiff*60 + sdiff;

        hdiff = parseInt(split[0]) - parseInt(split2[0]);
        mdiff = parseInt(split[1]) - parseInt(split2[1]);
        sdiff = parseInt(split[2]) - parseInt(split2[2]);
        var secTotal = hdiff*3600 + mdiff*60 + sdiff;
        rv.current_state = 100.0 * secElapsed / secTotal;

        if (typeof(data.titles.current) == "undefined") {
            // no current, use theme text
            if (typeof(data.themes.current) == "undefined") {
                // no data in themes either, return empty texts - should not happen
                return rv;
            }
            rv.title = data.themes.current.title;
            if (rv.title == "") {
                // no title, fallback to theme title
                rv.title = data.themes.current.theme_title;
            }
            rv.name = data.themes.current.name;
            return rv;
        }
         
        var c = data.titles.current;
        rv.title = c.title;
        rv.name = c.name;
        rv.end_time = c.est_end_time;

        // check type
        rv.type = getType(c.type);
        return rv;
    }

    function updateCoverLetter(data) {
        var path = "/wp-content/themes/patmos/assets/images/radio/covers/";
        var imgs = [
        /*"1_Pappia_kyydissa.jpg",
        "1Toiminnanjohtajan_vartti_1024px.jpg",
        "1USKONTOA_JA_POLITTIIKKAA.jpg",
        "1UUSI_TVM_1024px_.jpg",
        "2Ajankohtafoorumi.jpg",
        "2KAHDEN_KADEN_APUA_1024px.jpg",
        "2KAHDEN_KADEN_APUA.jpg",
        "2SENIORITUNTI.jpg",
        "2USKONTOA_JA_POLITIIKKAA.jpg",
        "2UUSI_TVM_1024px.jpg",
        "3KAHDEN_KADEN_APUA_1024px.jpg",
        "3Toiminnanjohtajan_vartti_1024px.jpg",
        "4KAHDEN_KADEN_APUA.jpg",
        "AAMUHARTAUS_1024px.jpg",
        "AAMUHARTAUS_AURINGONNOUSU_1024px.jpg",
        "AAMUHARTAUS.jpg",
        "AAMUHARTAUS_PELTO_1024px.jpg",
        "AAMU-LIVE_1024px.jpg",
        "AAMU_LIVE_TUMMEMPI_1024px.jpg",
        "AAMUVIERAS_1024px.jpg",
        "AAMUVIERAS_KUPPI_1024px.jpg",
        "AJANKOHTAFOORUMI_1024px.jpg",
        "AJANKOHTAFOORUMI_1.jpg",
        "EVANKELISTAN_EVAITA2.jpg",
        "EVANKELISTAN_EVAITA.jpg",
        "EVANKELIUMIHETKI2.jpg",
        "EVANKELIUMIHETKI3.jpg",
        "EVANKELIUMIHETKI.jpg",
        "ILOSANOMAPIIRI2.jpg",
        "ILOSANOMAPIIRI3.jpg",
        "ILOSANOMAPIIRI.jpg",
        "ILTAPAIVA_TONI_RANDEN_1024px.jpg",
        "ILTAPAIVA_TONI_RANDENIN_SEURASSA.jpg",
        "KAHDEN_KADEN_APUA_1024px.jpg",
        "KAKSIN_KASIN_MAAILMAAN.jpg",
        "KELLO-SENIORITUNTI.jpg",
        "KOHTAAMISPAIKKA.jpg",
        "KRISTILLINEN_DOGMATIIKKA_1024px.jpg",
        "Lintu_ja_Toni_Randen.jpg",
        "OIKEASTI_LUTERILAINEN.jpg",
        "PAIVAN_PAKINA3.jpg",
        "PAIVAN_PAKINA4.jpg",
        "PAIVAN_PAKINA.jpg",
        "PAIVA_PAKINA2.jpg",
        "PAIVI_KYYRON_SEURASSA_1024px.jpg",
        "PAPPIA_KYYDISSA_1024px.jpg",
        "PAPPIA_KYYDISSA1_1024px.jpg",
        "PAPPIA_KYYDISSA2_1024px.jpg",
        "PATMOS_AANI.jpg",
        "PATMOS_BLOGI2.jpg",
        "PATMOS_BLOGI.jpg",
        "PATMOS_RADIO_1024px_1.jpg",
        "PATMOS_RUKOILEE2.jpg",
        "PATMOS_RUKOILEE.jpg",
        "RADIO_PATMOKSEN_AAMUHARTAUS2.jpg",
        "RADIO_PATMOKSEN_AAMUHARTAUS3.jpg",
        "RADIO_PATMOKSEN_AAMUHARTAUS.jpg",
        "RADIO_PATMOS_1024px_rouheus.jpg",
        "RADIO_PATMOS.jpg",
        "RADIO_PATMOS_.jpg",
        "RADIO_PATMOS_PATMOS_AANI3.jpg",
        "RADIO_PATMOS_PATMOS_AANI_ISOMPI.jpg",
        "Radio_Patmos-Studio-PLAYER_PLACEHOLDER.jpg",
        "Radio_Patmos-Studio-PLAYER_PLACEHOLDER_TUMMEMPI.jpg",
        "RIKUN_MATKASSA_BLOGI_1024px.jpg",
        "Rikun_matkassa_Blogi.jpg",
        "RIKUN_MATKASSA.jpg",
        "RISTIN_KANTAJIA.jpg",
        "'RISTIN KANTAJIA_LAMPIMAMPI.jpg'",
        "ROUHEA_RADIO_PATMOS.jpg",
        "RUKOUSMINUUTTI2.jpg",
        "RUKOUSMINUUTTI.jpg",
        "Rukousta_kansojen_puolesta_1024px.jpg",
        "Rukousta_kansojen_puolesta_1024px_jpg.jpg",
        "RUKOUSTA_KANSOJEN_PUOLESTA_1.jpg",
        "'RUKOUSTA_KANSOJEN_PUOLESTA (1).jpg'",
        "RUKOUSTA_KANSOJEN_PUOLESTA2.jpg",
        "RUKOUSTA_KANSOJEN_PUOLESTA_3.jpg",
        "SENIORIT_TUNTI.jpg",
        "SENIORITUNTI_1H.jpg",
        "SENIORITUNTI2_1H.jpg",
        "SENIORITUNTI_KIIKUT2.jpg",
        "SENIORITUNTI_KIIKUT.jpg",
        "SENIORITUNTI_KLO.jpg",
        "STUDIO_24_1024px.jpg",
        "STUDIO_24_2.jpg",
        "STUDIO_24_4.jpg",
        "STUDIO_24.jpg",
        "SUOMI_RUKOILEE_2.jpg",
        "SUOMI_RUKOILEE.jpg",
        "THRU_THE_BIBLE2.jpg",
        "THRU_THE_BIBLE3.jpg",
        "THRU_THE_BIBLE.jpg",
        "TOIMINNANJOHTAJAN_VARTTI_1024px.jpg",
        "TOIMINNANJOHTAJAN_VARTTI_ASIAVIIVA_1024px.jpg",
        "TOIMINNANJOHTAJAN_VARTTI_PINSSI_KORJATTU.jpg",
        "TOIMITTAJIEN_TUNTI_1024px.jpg",
        "TVM_3_1024px.jpg",
        "TVM_UUSI_1024px.jpg",
        "TVM_UUSI_ERI_ASETTELU_1024px.jpg",
        "USKONTOA_JA_POLITIIKKAA2.jpg",
        "USKONTOA_JA_POLITIIKKAA3.jpg",
        "USKONTOA_JA_POLITIIKKAA.jpg",
        "USKONTOA_POLITIIKKA_TURUNEN.jpg",
        "USKONTO_POLITIIKKA_TURUNEN1.jpg",
        "UUSI_RADIO_PATMOS_AAMU.jpg",
        "UUSI_RADIO_PATMOS_PATMOS_AANI.jpg",
        "UUSI_TVM_1024px.jpg",
        "UUSI_TVM_1024px_.jpg",
        "UUSI_TVM_RAAMATTU_ROUHEUTTA.jpg",
        "UUSI_TVM_VALON_SATEET_1024px.jpg",
        "VIIKON_AHVIO_1024px.jpg",
        "VIIKON_AHVIO2.jpg"*/
        path+"ROUHEA_RADIO_PATMOS.jpg",
        path+"Radio_Patmos-Studio-PLAYER_PLACEHOLDER_TUMMEMPI.jpg",
        path+"RADIO_PATMOS_PATMOS_AANI_ISOMPI.jpg"
        ]

        if (window.radioCoverImages) {
            imgs = window.radioCoverImages;
        }

        var item = imgs[Math.floor(Math.random()*imgs.length)];

        let defaultImg = "/wp-content/themes/patmos/assets/images/radio/cover-default.jpg";
        let coverElem = document.getElementById("player-background");
        if (coverElem) {
            coverElem.style.backgroundImage = "url(" + item + ")";
            //coverElem.style.backgroundImage = "url(" + defaultImg + ")";
        }
    }

    function updateNowPlaying(data) {
        if (typeof(data.titles) == "undefined") {
            $('#now-playing-info').html("<div></div>")
            return;
        }

        var now = getData(data);

        var icon = "";
        if (now.type == "music") {
            icon = '<span>&#x266B;</span> ';
        } 
        var html = '<h3 class="now-playing-title">' + icon + now.title+'</h3>';

        var bar_width = '';
        var end_time = '';
        if (now.current_state != '') {
            bar_width = ' style="width:'+ now.current_state+'%"';
        }
        if (now.name != '') {
            html += "<div>" + now.name + "</div>";
        }

        if (now.end_time) {
            end_time = '<div>'+now.end_time+'</div>';
        }

        html += '<div class="now-playing-progress"><div>'+now.scheduled_time.substring(0,5)+'</div>'
        html += '<div class="progress-bar"><div class="progress-indicator"'+bar_width+'></div></div>'
        html += end_time + '</div>';

        $('#now-playing-info').html(html);
    } 
    
    getAds();

    //var path = "/wp-content/uploads/zenon/now-playing.json";
    var path = "/wp-content/uploads/zenon/listening_now.json";

    setTimeout(function() {
      $.getJSON(path, function (result) {
        //$('#now-playing-info').html(result);
        updateNowPlaying(result);
        updateCoverLetter(result);
    });}, 200);

    setInterval(function() {
      $.getJSON(path, function (result) {
        updateNowPlaying(result);
        //updateCoverLetter(result);
    });}, 10000);

    jQuery("#volume").slider({
      min: 0,
    	max: 100,
      value: 100,
      range: "min",
      slide: function(event, ui) {
      	setVolume(ui.value / 100);
      }
  	});

  	function setVolume(myVolume) {
      var myMedia = document.getElementById('patmos-radio-stream');
      myMedia.volume = myVolume;
      $('#volume').slider({value: myVolume});
  	}
  
  });

})(jQuery);
